import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import BlogList from "../../Components/BlogList/BlogList";
import Footer from "../../Components/Common/Footer";

class BlogListPage extends Component {
  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <Fragment>
        <TopNavigation />
        <div className="responsive-padding-top">
          <BlogList />
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default BlogListPage;
